import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserGroup } from 'app/shared/models/user-group.model';
import { UserService } from 'app/shared/services/user.service';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-user-group-selection-list',
  templateUrl: './user-group-selection-list.component.html',
  styleUrls: ['./user-group-selection-list.component.scss']
})

export class UserGroupSelectionListComponent implements OnInit {
  @Input() active: boolean = true;
  @Input() label: string;
  @Input() hideLabel: boolean = false;
  @Input() selectedUserGroupCode: number;
  @Input() selectUserGroupText: string;
  @Output() userGroupChangedEvent: EventEmitter<UserGroup> = new EventEmitter<UserGroup>();

  userGroupList$: Observable<UserGroup[]>;
  UserGroupListLoading = false;
  userGroupListinput$ = new Subject<string>();

  constructor(private userService: UserService) {
  }

  ngOnInit() {
    this.loadUserGroupList();
  }

  private loadUserGroupList() {
    this.userGroupList$ = this.userService.getList<UserGroup>("/users/group/list");
  }

  selectedUserGroupChanged(userGroup: UserGroup) {
    this.userGroupChangedEvent.emit(userGroup);
  }
}
